/* Input-group telefono (prefisso con bandiera + numero), coerente con .cform */

.phone-group {
  display: flex;
  align-items: stretch;
  position: relative;
  border: 1.5px solid var(--sh-line);
  border-radius: 12px;
  background: #fff;
  transition: border-color 0.15s;
}

.phone-group:focus-within {
  border-color: var(--sh-navy-500);
}

.phone-cc {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  background: transparent;
  border: 0;
  border-right: 1.5px solid var(--sh-line);
  border-radius: 12px 0 0 12px;
  cursor: pointer;
  font: inherit;
  color: var(--sh-ink);
  white-space: nowrap;
}

.phone-cc .dial { font-size: 15px; }
.phone-cc .chev { width: 11px; height: 11px; opacity: 0.5; }

/* Override del .cform input per l'input dentro il group (no bordo/raggio propri) */
.cform .phone-group .phone-num {
  flex: 1;
  min-width: 0;
  border: 0;
  border-radius: 0 12px 12px 0;
  background: transparent;
  padding: 14px 16px;
}
.cform .phone-group .phone-num:focus { border: 0; }

.flag {
  display: inline-block;
  width: 20px;
  height: 14px;
  border-radius: 3px;
  overflow: hidden;
  flex-shrink: 0;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.12);
}
.flag svg { display: block; width: 100%; height: 100%; }

.phone-menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 30;
  margin: 0;
  padding: 6px;
  list-style: none;
  min-width: 220px;
  max-height: 260px;
  overflow: auto;
  background: #fff;
  border: 1.5px solid var(--sh-line);
  border-radius: 12px;
  box-shadow: 0 14px 32px rgba(11, 37, 69, 0.16);
}

.phone-opt {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 9px 10px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  font: inherit;
  font-size: 14px;
  color: var(--sh-ink);
  text-align: left;
}

.phone-opt:hover,
.phone-opt.is-active {
  background: rgba(11, 37, 69, 0.06);
}

.phone-opt .name { flex: 1; }
.phone-opt .dial { color: var(--sh-fg-muted); font-size: 13px; }
